(function() {
    angular
        .module("usersModule")
        .controller("UsersController", UsersController)

    UsersController.$inject = [
        "$rootScope",
        "$scope",
        "$filter",
        "$location",
        "$state",
        "usersService",
        "DTOptionsBuilder",
        "DTColumnBuilder"
    ]

    function UsersController(
        $rootScope,
        $scope,
        $filter,
        $location,
        $state,
        usersService,
        DTOptionsBuilder,
        DTColumnBuilder
    ){
        "use strict"

        if ($location.url().indexOf("current-user-details") >= 0) {
            $state.go("user-details", { user_id: $rootScope.user.id })
        }

        $rootScope.title = "Users | WANCO"

        $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            return usersService.getUsers($rootScope.selectedCustomerID).then(function(data) {
                return data
            })
        })
        .withPaginationType("simple")
        .withOption("bFilter", false)
        .withOption("bAutoWidth", true)
        .withLanguage({
            "sEmptyTable":     "No data available in table",
            "sInfo":           "Showing _START_ to _END_ of _TOTAL_",
            "sInfoEmpty":      "Showing 0 to 0 of 0",
            "sLengthMenu":     "View _MENU_",
            "sLoadingRecords": "Loading...",
            "sZeroRecords":    "No matching records found",
            "oPaginate": {
                "sNext":     '<button class="btn btn-default pull-right"><i class="fa fa-angle-right"></i></button>',
                "sPrevious": '<button class="btn btn-default"><i class="fa fa-angle-left"></i></button>'
            },
            "oAria": {
                "sSortAscending":  ": activate to sort column ascending",
                "sSortDescending": ": activate to sort column descending"
            }
        })
        .withOption("sDom", '<"top">rt<"clearfix"><"pull-left"l><"text-right"pfi><"clear">')
        .withOption("responsive", true)

        $scope.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle("Username")
                .renderWith(function(data, type, full, meta) {
                    return '<a href="/user-details/id/' + data.id + '">' + data.username + "</a>"
                }),
            DTColumnBuilder.newColumn("customer_name").withTitle("Customer"),
            DTColumnBuilder.newColumn("role").withTitle("Role"),
            DTColumnBuilder.newColumn("phone").withTitle("Phone"),
            DTColumnBuilder.newColumn(null).withTitle("Email")
                .renderWith(function(data, type, full, meta) {
                    return '<a href="mailto:' + data.email + '">' + data.email + "</a>"
                }),
            DTColumnBuilder.newColumn(null).withTitle("Last Signed In")
                .renderWith(function(data, type, full, meta) {
                    return $filter("date")(data.last_sign_in_at, "yyyy-MM-dd")
                }),
            DTColumnBuilder.newColumn(null).withTitle("Last Seen")
                .renderWith(function(data, type, full, meta) {
                    return $filter("date")(data.last_seen_at, "yyyy-MM-dd")
                })
        ]
    }
})()
